import { render } from "./Sessions.vue?vue&type=template&id=0ae2d994&ts=true"
import script from "./Sessions.vue?vue&type=script&lang=ts"
export * from "./Sessions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__